import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/Permissions/";
    return {
        GetPermissionsObjects(request) {
            var url = baseUrl + "GetPermissionsObjects";
            return Proxy.Post(url, request);
        },
    };
})()